import React, {memo} from 'react';
import {NavLink} from 'react-router-dom';
import {PAGES_URL} from '../../helpers/constants';
import {DashboardLayout} from '../../components';

const ROUTES = [
  {
    name: 'Audit Logs',
    path: PAGES_URL.AUDIT_LOGS,
    key: 'audit',
  },
  {
    name: 'Export Logs',
    path: PAGES_URL.EXPORT_LOGS,
    key: 'export',
  },
];

function Layout({children}) {
  return (
    <DashboardLayout
      breadCrumbs={<p className="text-tiny font-normal text-deepBlue">Logs</p>}
    >
      <div className="py-3">
        <div className="rounded-md mt-4 bg-[#F7F7F7] w-fit p-1 flex items-center gap-2 overflow-x-auto">
          {ROUTES.map((route, index) => (
            <NavLink
              key={index}
              end
              to={route.path}
              className={({isActive}) =>
                `px-7 py-1.5 min-h-8 text-sm flex items-center justify-center rounded-lg shadow-[0px_4px_32px_-4px,rgba(199,196,196,0.18)] ${
                  isActive
                    ? 'text-black bg-white shadow-tabs'
                    : 'text-grey-500 bg-transparent'
                }`
              }
            >
              {route.name}
            </NavLink>
          ))}
        </div>
      </div>
      {children}
    </DashboardLayout>
  );
}

export default memo(Layout);
